module.exports = __webpack_public_path__ + "img/ata.916ed11f.png";